<div>
  <div class="row align-items-end">
    <div class="col-12 col-md col-lg-auto form-group">
      <div>
        <app-custom-button
          class=""
          [title]="'dispenserAgreement.downloadOpenShipments' | cxTranslate"
          [showSpinner]="downloadingOpenShipmentsOrdersCsv"
          styleClass="btn-small mr-2 my-1"
          (clicked)="downloadOpenShipmentsOrders()"
        ></app-custom-button>
        <button class="btn btn-primary btn-small mr-2 my-1" (click)="openShipmentCreditClaims()">
          {{ 'dispenserAgreement.creditClaimsHistory' | cxTranslate }}
        </button>
      </div>
      <div>
        <button class="btn btn-primary btn-small mr-2 my-1" (click)="createNewAgreement()">
          {{ 'dispenserAgreement.newAgreement' | cxTranslate }}
        </button>
        <button class="btn btn-primary btn-small my-1" (click)="createDispenserCreditRequest()">
          {{ 'dispenserAgreement.createDispenserCreditRequest' | cxTranslate }}
        </button>
      </div>
    </div>
    @if (!showInitialLoader) {
      <div class="col form-group col-sm-3 col-md-3 col-lg-3 col-sm-3">
        <app-custom-search-input
          title="Search Agreement"
          placeholder="Search by End User Name or Agreement Number #"
          (eventSearch)="onSearch($event)"
        ></app-custom-search-input>
      </div>
    }
    <div class="col col-sm col-md-auto form-group">
      <app-custom-select
        [title]="'shared.filterBy' | cxTranslate"
        (changeValue)="filterChange($event)"
        [options]="filterOptions"
        [clearable]="true"
        placeHolder="Status"
      ></app-custom-select>
    </div>

    <div class="col col-sm col-md-auto form-group">
      <app-custom-select
        [title]="'shared.sortBy' | cxTranslate"
        (changeValue)="sortChange($event)"
        [clearable]="true"
        [options]="options"
        [placeHolder]="'shared.select' | cxTranslate"
      ></app-custom-select>
    </div>
  </div>
</div>

@if (agreementList?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="orderCode"
    override="DispenserAgreementHistoryRow"
    [rows]="agreementList.results"
    [pagination]="agreementList.pagination"
    (changePagination)="pageChange($event + 1)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (showMessageWhenNoData) {
    <app-custom-error
      [errorMessage]="'shared.noAgreements' | cxTranslate"
    ></app-custom-error>
  }
}


@if (showLoaderOnStartupOrWhenNoData) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
